import React from "react";
import "../styles/Blog.css";

function Blog() {
  // const blogs = [
  //   {
  //     title: "Understanding Intellectual Property Protection",
  //     link: "https://exampleblog.com/ip-law",
  //     description: "Learn the basics of patents, trademarks, and copyrights.",
  //     image: "/blog1.jpg"
  //   },
  //   {
  //     title: "Navigating Family Law in India",
  //     link: "https://exampleblog.com/family-law",
  //     description: "Insights into divorce, custody, and mediation processes.",
  //     image: "/blog2.jpg"
  //   },
  //   {
  //     title: "Estate Planning Essentials",
  //     link: "https://exampleblog.com/estate-planning",
  //     description: "How wills, trusts, and inheritance laws affect you.",
  //     image: "/blog3.jpg"
  //   },
  //   {
  //     title: "Navigating Family Law in India",
  //     link: "https://exampleblog.com/family-law",
  //     description: "Insights into divorce, custody, and mediation processes.",
  //     image: "/blog2.jpg"
  //   },
  //   {
  //     title: "Estate Planning Essentials",
  //     link: "https://exampleblog.com/estate-planning",
  //     description: "How wills, trusts, and inheritance laws affect you.",
  //     image: "/blog3.jpg"
  //   }
  // ];
  const blogs = [];

  return (
    <section id="blog">
      <div className="section-container">
        <h2>Blog</h2>
        <div className="blog-grid">
          {blogs.length > 0 ? (
            blogs.map((blog, index) => (
              <a
                key={index}
                href={blog.link}
                target="_blank"
                rel="noopener noreferrer"
                className="blog-card"
              >
                <img
                  src={blog.image || "/AboutUs.jpg"}
                  alt={blog.title}
                  className="blog-image"
                  onError={(e) => { e.target.src = "/AboutUs.jpg"; }}
                />
                <h3>{blog.title}</h3>
                <p>{blog.description}</p>
              </a>
            ))
          ) : (
            <div className="coming-soon">
              <h3>Coming Soon</h3>
              <p>We’re working on insightful articles. Stay tuned!</p>
            </div>
          )}
        </div>
      </div>
    </section>
  );
}

export default Blog;
